module.exports = __webpack_public_path__ + "static/img/5.657ef72.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer5/5.jpg
// module id = phFu
// module chunks = 1